import React from 'react';
import { style, classes } from 'typestyle';
import { ComponentProps, inject, deps, observer } from '../../../lib/component';
import { TrackSchemaWithUsage } from '../../../modules/page/checkout/model';
import { InfoOutline } from '../atoms/icons/InfoOutline';
import { rebrand } from '../../../theme/color';
import { flexRoot, start } from 'csstips';
import { spacing } from '../../../theme/spacing';
import { Link } from '../atoms/Link';
import { px } from 'csx';

interface ClaimsManagedStatusProps extends ComponentProps {
  track: TrackSchemaWithUsage;
}

const styles = {
  content: style(flexRoot, start, {
    gap: spacing.XXSMALL,
    fontSize: px(12),
    color: rebrand.neutralOnLight[70].toString(),
  }),
  licenseText: style({
    display: 'block',
    $nest: {
      '& a': {
        color: 'currentColor',
        textDecoration: 'underline',
      },
    },
  }),
};

export const ClaimsManagedStatus: React.FC<ClaimsManagedStatusProps> = inject(deps)(
  observer(
    ({
      track,
      controller: {
        modal,
        page: { checkout },
      },
    }) => {
      const isClaimsManaged = track.reporting_party.slug === 'umg';

      let iconColor = rebrand.secondary[70].toHexString();
      let timeframe = '30 minutes';

      if (isClaimsManaged) {
        iconColor = rebrand.semantic.warning[60].toHexString();
        timeframe = '48 hours';
      }

      const handleClickEula = () => {
        checkout.loadEulaInfo(track);
        modal.showEulaModal(track);
      };

      return (
        <div className={styles.content}>
          <InfoOutline color={iconColor} size={15} />
          <div className="">
            Claims are usually cleared within {timeframe}.
            <span className={styles.licenseText}>
              View the{' '}
              <Link onClick={handleClickEula} href="#">
                license agreement
              </Link>{' '}
              for more info.
            </span>
          </div>
        </div>
      );
    }
  )
);
